import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import Alert from "../../components/extras/Alert";
import WaiterData from "../../data/WaiterData";
import SaleData from "../../data/SaleData";
import localDB from "../../data/localDB";

class OpenTable extends Component {

    constructor() {
        super();
        this.state = {
            open: false,
            title: "",
            order: {
                waiter: {},
                quantity: 1
            },
            quantity_error: false,
            label_button: " ",
            table: {number: 0},
            sending: false,
            waiters: [],
            index: null
        };

        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleWaiterChange = this.handleWaiterChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    async initialFetch() {
        if(localDB.get('waiters')){
            this.setState({waiters: localDB.get('waiters')});
           this.updateData();
        }else {
            this.updateData();
        }
    };

    updateData = () =>{
        WaiterData.select().then(waiters =>{
            localDB.set('waiters', waiters);
            this.setState({waiters});
        });
    };

    handleOpen = (table, index) => {
        this.setState({open: true, table, index});
    };

    handleClose = () => {
        this.setState({open: false, order: {waiter: {}, quantity: 1}, quantity_error: false});
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.order.quantity < 1 || this.state.order.quantity === '') {
            this.setState({quantity_error: true});
        } else {
            this.setState({sending: true});
            let tableId = this.state.table.id;
            let data = {order: this.state.order, table: tableId};
            data.order.waiter = data.order.waiter ? data.order.waiter.key : null;
            data.order.type = 1;
            data.order.state = 1;
            data.order.client = null;
            SaleData.open(data, (response) => {
                if (response !== null && response.hasOwnProperty('id')) {
                    localDB.saveSaleStorage(response.sale, 'sale');
                    this.props.callbackOpenTable(response, this.state.index);
                } else {
                    this.refs.alert.open({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                }
                this.setState({sending: false});
            });
        }
    };

    handleQuantityChange = (event) => {
        let quantity = update(this.state, {
            order: {
                quantity: {
                    $set: event.target.value
                }
            }
        });
        this.setState(quantity);
        if (event.target.value.trim() < 1 || event.target.value.trim() === '') {
            this.setState({quantity_error: true})
        } else {
            this.setState({quantity_error: false})
        }
    };

    handleWaiterChange = (result) => {
        let waiter = update(this.state, {
            order: {
                waiter: {
                    key: {$set: result},
                    value: {$set: result}
                }
            }
        });
        this.setState(waiter);
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>{` Abrir Mesa Nº ${this.state.table.number}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Select search noResultsMessage='No hay registros'
                                                         value={this.state.order.waiter ? this.state.order.waiter.key : ''}
                                                         onChange={(e, {value}) => this.handleWaiterChange(value)}
                                                         label='Mesero' options={this.state.waiters}
                                                         placeholder='Mesero'/>
                                            <Form.Input label='Cantidad de Personas' value={this.state.order.quantity}
                                                        type='number' min={1} placeholder='Cantidad de Personas'
                                                        onChange={this.handleQuantityChange}
                                                        error={this.state.quantity_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary disabled={this.state.sending} loading={this.state.sending} icon='food'
                                labelPosition='left' onClick={this.handleSubmit} content='Abrir mesa'/>
                    </Modal.Actions>
                </Modal>
                <Alert ref='alert'/>
            </div>
        );
    }
}

export default OpenTable;



// WEBPACK FOOTER //
// ./src/components/sale/OpenTable.js